import {
  FETCH_OBJECT_NUM_FAILURE,
  FETCH_OBJECT_NUM_REQUEST,
  FETCH_OBJECT_NUM_SUCCESS,
} from '../../reducers/types';
import { getObjectNumListService } from '../../services/specServices/ObjectNumService';

export const getObjectNumListAction = (array = null) => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCH_OBJECT_NUM_REQUEST,
      });
      const response = await dispatch(getObjectNumListService(array));
      if (response.status === 200) {
        dispatch({
          type: FETCH_OBJECT_NUM_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({
          type: FETCH_OBJECT_NUM_FAILURE,
        });
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  };
};
